// extends
import { ExtendedContainer, ExtendedSprite } from "@aceroll/core";

// game objects
import { SkySlotMachine } from "@aceroll/core";

// configs
import { config } from './config';
import { symbolsMap } from './symbols-map';

export class SlotMachine extends SkySlotMachine {
    mainBackgroundSprite = null;
    bonusBackgroundSprite = null;

    constructor() {
        super(symbolsMap, config);

        this.setup();
    }

    setup() {
        this.setupBackground();
        super.setup();
    }

    setupBackground() {
        this.background = new ExtendedContainer('slot-machine-background');

        this.mainBackgroundSprite = ExtendedSprite.fromSpriteSheet('common-reel_frame_main');

        this.mainBackgroundSprite.x = 346;
        this.mainBackgroundSprite.y = 500;
        this.mainBackgroundSprite.scale.set(1.001, 1.002);

        this.bonusBackgroundSprite = ExtendedSprite.fromSpriteSheet('common-reel_frame_fs');

        this.bonusBackgroundSprite.alpha = 0;
        this.bonusBackgroundSprite.visible = false;

        this.background.addChild(this.mainBackgroundSprite, this.bonusBackgroundSprite);

        this.addChild(this.background);
    }

    async onBonus() {
        await Promise.all([
            this.mainBackgroundSprite.hide(200),
            this.bonusBackgroundSprite.show(200)
        ]);
    }

    async exitBonus() {
        await Promise.all([
            this.bonusBackgroundSprite.hide(200),
            this.mainBackgroundSprite.show(200)
        ]);
    }

    // visual

    async playRespinTrigger(position, counter) {
        await this.grid.playRespinTrigger(position, counter);
    }

    async updateRespinCounter(count) {
        await this.grid.updateRespinCounter(count);
    }

    async stick(positions) {
        await this.grid.stick(positions);
    }

    unstick(positions) {
        this.grid.unstick(positions);
    }

    unstickAll() {
        this.grid.unstickAll();
    }

    async playMultipliers(position) {
        await this.grid.playMultiplier(position);
    }
}